/*export interface PxQIBM{
  PRECIO: number;
  TONELA: number;
  MONEDA: number;
  CEREAL: number;
  IMPBON: number;
  PORBON: number;
  MONBON: number;
}

export interface PxQIBMString{
  PRECIO: string;
  TONELA: string;
  MONEDA: number;
  CEREAL: number;
  IMPBON: string;
  PORBON: string;
  MONBON: number;
}*/


import { Indicator } from '@shared-logic/prices/price-to-fix.interface';

export interface FailedResponse {
  nroOfCall: number;
  ID: string;
  DESCRIPCION: string;
  status: {
    status: string;
    message: string;
    messageError: {
      Contrato: number | any;
      ID: string;
      msg: string;
    };
  };
  data: {
    ID: string;
    Accion: string;
    Confirmado: string;
    NombreVendedor: string;
    Contrato: number;
    indicators?: Indicator[]; // Array of indicators with status
  };
}

export interface QuotaResponse {
  date: string; // ISO format string or the raw input? Usually string for JSON
  trucks: number;
  assignmentType: string;
  status: 'ok' | 'error';
  message?: string;
  isRetry?: boolean;
}

export interface ContractProcessResult {
  orderId: string;
  contractNumber: number;
  status: 'ok' | 'error';
  message?: string;
  sellerCode?: number; // Code to identify seller in frontend

  // Detailed results
  indicators?: Indicator[];
  quotas?: QuotaResponse[];
}

export interface Response<T> {
  status: StatusResponse;
  data: {
    Accion: string;
    msg: T;
  };
}

export interface StatusResponse {
  status: string;
  message: string;
  messageError: string;
}

export interface RucaAndSisa {
  "Vendedor": string,
  "Producción Propia": string, //S o N
  "ExisteSisa": string, //S o N
  "ExisteRuca": string, //S o N
  "COD.ACTIVIDAD RUCA": string, //Numero
  "COD.ACTIVIDAD SISA": string, //Numero
  "Estado SISA": number, //Numero 0,1,2,3,9
}

export interface HowSellValidation {
  "Vendedor": string,
  "ComoVende": string,
  "Validación": string
}

export type ResponseRucaAndSisa = Response<RucaAndSisa>;
export type ResponseHowSell = Response<HowSellValidation>;
export type ResponsePurchaseMethod = Response<PurchaseMethodValidation>;
export type ResponsePurchaseMethodDefault = Response<PurchaseMethodDefault>;

export interface PurchaseMethodValidation {
  Comprador: string;
  'Como Compra': string;
  ExisteSisa: string;
  'COD.ACTIVIDAD SISA': string;
  'Estado SISA': number;
}

// IBM function COMODEF (program WEB0053) — per-buyer Purchase Method default.
// Confirmed shape via a live staging call (buyer 285): plain JSON, same
// status/data/Accion/msg envelope as every other function here, no special
// parsing needed.
export interface PurchaseMethodDefault {
  Comprador: string;
  'Valor por Defecto': string; // 'Sin Valor' | 'C' | 'P'
}

export interface ResponseIBM {
  status: {
    status: string;
    message: string;
    messageError: {
      msg: string;
    };
  }
  data: any;
}

export interface TableIBM {
  collection: string,
  data: any,
  length: number,
  lastUpdate?: Date,
}
